import { ExprNode, Ident } from '@mode-switch/express';
export var RelationNode;
(function (RelationNode) {
    let Type;
    (function (Type) {
        Type["Select"] = "SELECT";
        Type["Core"] = "CORE";
        Type["Proj"] = "PROJ";
        Type["From"] = "FROM";
        Type["Table"] = "TABLE";
        Type["Join"] = "JOIN";
        Type["Where"] = "WHERE";
        Type["Group"] = "GROUP";
        Type["Having"] = "HAVING";
        Type["Window"] = "WINDOW";
        Type["Order"] = "ORDER";
        Type["OrderTerm"] = "ORDER_TERM";
        Type["Limit"] = "LIMIT";
        Type["Offset"] = "OFFSET";
        Type["In"] = "IN";
        Type["NotIn"] = "NOT_IN";
        Type["Distinct"] = "DISTINCT";
    })(Type = RelationNode.Type || (RelationNode.Type = {}));
    let JoinOp;
    (function (JoinOp) {
        JoinOp["Left"] = "LEFT";
        JoinOp["Inner"] = "INNER";
    })(JoinOp = RelationNode.JoinOp || (RelationNode.JoinOp = {}));
    function project(expr, alias) {
        const id = Ident.next('R');
        const ident = ExprNode.Ident.make(alias);
        return { expr, alias: ident, id, type: "PROJ" };
    }
    RelationNode.project = project;
    function table(name) {
        const id = Ident.next('R');
        const ident = ExprNode.Ident.make(name);
        return { name: ident, id, type: "TABLE" };
    }
    RelationNode.table = table;
    function from(source, alias) {
        const id = Ident.next('R');
        const ident = ExprNode.Ident.make(alias);
        return { source, alias: ident, id, type: "FROM" };
    }
    RelationNode.from = from;
    function fromTable(name, alias) {
        return from(table(name), alias || name);
    }
    RelationNode.fromTable = fromTable;
    function join(operator, source, predicate, alias) {
        const id = Ident.next('R');
        const ident = ExprNode.Ident.make(alias);
        return { source, predicate, operator, alias: ident, id, type: "JOIN" };
    }
    RelationNode.join = join;
    function where(exprs = []) {
        const id = Ident.next('R');
        return { exprs, id, type: "WHERE" };
    }
    RelationNode.where = where;
    function group(exprs = []) {
        const id = Ident.next('R');
        return { exprs, id, type: "GROUP" };
    }
    RelationNode.group = group;
    function having(exprs = []) {
        const id = Ident.next('R');
        return { exprs, id, type: "HAVING" };
    }
    RelationNode.having = having;
    function order(terms = []) {
        const id = Ident.next('R');
        return { terms, id, type: "ORDER" };
    }
    RelationNode.order = order;
    function orderTerm(expr, sortOrder) {
        const id = Ident.next('R');
        return { expr, order: sortOrder, id, type: "ORDER_TERM" };
    }
    RelationNode.orderTerm = orderTerm;
    function window(exprs = []) {
        const id = Ident.next('R');
        return { exprs, id, type: "WINDOW" };
    }
    RelationNode.window = window;
    function limit(expr) {
        const id = Ident.next('R');
        return { expr, id, type: "LIMIT" };
    }
    RelationNode.limit = limit;
    function offset(expr) {
        const id = Ident.next('R');
        return { expr, id, type: "OFFSET" };
    }
    RelationNode.offset = offset;
    function core(source, partial = {}) {
        const id = Ident.next('R');
        return { ...partial, id, from: source, type: "CORE" };
    }
    RelationNode.core = core;
    function select(source, partial = {}) {
        const id = Ident.next('R');
        const cores = [...(partial.cores || []), source];
        return { ...partial, id, cores, type: "SELECT" };
    }
    RelationNode.select = select;
})(RelationNode || (RelationNode = {}));
